import { atom } from 'jotai'

import { TQrData } from '@/generator/shared'
import { DOWNLOAD_QR_ACTION_TYPES } from '@/utils/downloadQrCode'

export const subExpiredDialogAtom = atom<boolean>(false)

export const downloadQrDialogAtom = atom<boolean>(true)
export const downloadQrTypeAtom =
	atom<DOWNLOAD_QR_ACTION_TYPES>('downloadAsPng')

export const qrCodeAtom = atom<TQrData | null>(null)

export const qrDownloadSuccessDialogAtom = atom<boolean>(false)
export const qrDownloadCompletedAtom = atom<boolean>(false)
